module.exports = __webpack_public_path__ + "static/img/img06.26e32b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img06.png
// module id = a1Kk
// module chunks = 1